import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/apiClient";
import SEO from "@/components/SEO";
import CoverageList from "@/components/CoverageList";

export default function InitiativeDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => { api.get(`/initiatives/${slug}`).then(({ data }) => setData(data)).catch(() => setNotFound(true)); }, [slug]);

  if (notFound) return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center">
      <div className="font-serif text-7xl text-npst-goldBorder">404</div>
      <Link to="/our-work" className="inline-flex items-center gap-2 mt-8 text-sm font-semibold uppercase tracking-[0.12em] text-npst-navy">← Back to Our Work</Link>
    </div>
  );
  if (!data) return <div className="py-32 text-center text-npst-muted animate-pulse">Loading…</div>;
  const { initiative: it, related_pils, media_coverage } = data;

  return (
    <div className="fade-in max-w-4xl mx-auto px-4 sm:px-6 py-12">
      <SEO title={`${it.title} — NPST`} description={it.description} canonical={`${window.location.origin}/initiatives/${it.slug}`} />
      <button onClick={() => navigate("/our-work")} className="inline-flex items-center gap-2 text-sm text-npst-muted hover:text-npst-navy transition-colors mb-8"><ArrowLeft size={15} /> Our Work</button>
      <div className="label-eyebrow text-npst-gold mb-3">{it.category} · {it.status}</div>
      <h1 className="font-serif text-4xl sm:text-5xl font-semibold text-npst-ink tracking-tight leading-tight">{it.title}</h1>
      <p className="mt-6 text-xl text-npst-inkSoft leading-relaxed">{it.description}</p>
      {it.body && <div className="prose-npst mt-8">{it.body.split("\n\n").filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}</div>}
      {related_pils?.length > 0 && (
        <div className="mt-12 pt-8 border-t border-npst-line">
          <div className="label-eyebrow text-npst-gold mb-4">Related Litigation</div>
          {related_pils.map((pil) => (
            <Link key={pil.pil_code} to={`/pil/${pil.pil_code.toLowerCase()}`} className="block group mb-3">
              <div className="font-mono text-xs text-npst-muted">{pil.court}</div>
              <div className="font-serif text-xl text-npst-ink group-hover:text-npst-navy transition-colors">{pil.title}</div>
            </Link>
          ))}
        </div>
      )}
      {media_coverage?.length > 0 && (
        <div className="mt-12 pt-8 border-t border-npst-line">
          <div className="label-eyebrow text-npst-gold mb-4">In the Media</div>
          <CoverageList items={media_coverage} />
        </div>
      )}
    </div>
  );
}
